import api from './client';

export const salesReturnsApi = {
  list:         (params?: any)  => api.get('/sales-returns', { params }),
  getSaleItems: (saleId: number) => api.get(`/sales-returns/sale/${saleId}`),
  createReturn: (data: any)     => api.post('/sales-returns', data),
};
